import BaseLayer from "./BaseLayer";
import {getPosString} from "../../../utils/utils";
import {tileViewerPlotColors} from "../../../utils/const";
import {drawCircle, drawLine, mapMotorToCanvas} from "../utils/map_utils";
import {Stack} from "@mui/material";

class T0Streak extends BaseLayer {
    id = "t0streak";
    label = "T0 Streak";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;
        let {streaks, deviceSettings, tileFlag, textColor, textSize} = this.props;
        if ("streaks" in streaks)
            streaks = streaks["streaks"];

        Object.values(streaks).forEach(streak => {
            let streakSecond = streak['second'];
            Object.values(streakSecond).forEach(value => {
                let ofAbandonedCounty = value["ofAbandonedCounty"] === undefined ? false : value["ofAbandonedCounty"];
                if (value['countyKey']['islandKey']['takeNumber'] === 0 && !ofAbandonedCounty) {
                    Object.values(value['scanCells']).forEach((scanCell, index) => {
                        let motorX = scanCell['position']['xPosition'];
                        let motorY = scanCell['position']['yPosition'];
                        let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                            {device_settings: deviceSettings});
                        if (tileFlag['reverseYTileOrder']['flagY'])
                            y = y_fields * (tile_height * uperpixel) - y;
                        let xImageCoord = Math.floor(x / (tile_width * uperpixel));
                        let yImageCoord = Math.floor(y / (tile_height * uperpixel));
                        let color = tileViewerPlotColors.startOfStripColor;
                        let draw = false;
                        let radius = 0.5 * tile_height * uperpixel;
                        if (index === 0) {
                            color = value['direction'] === 1 ? tileViewerPlotColors.startOfStripColor :
                                tileViewerPlotColors.startOfSubpathColor;
                            draw = true;
                        } else if (index === value['scanCells'].length - 1) {
                            radius = 0.3 * tile_height * uperpixel;
                            color = tileViewerPlotColors.endOfStripColor;
                            draw = true;
                        }
                        if (draw) {
                            let popup = (
                                <Stack>{
                                    "T0Streak ID: " + value['id'] + "Direction: " + value['direction'] +
                                    "Trace: " + value['traceID'] + "XID: " + value['fixedXId'] +
                                    "numFields: " + value['scanCells'].length +
                                    "collected Images: " + value['numImagesTakenWithTrigger'] +
                                    "Start: " + getPosString(value['startPos']) + " End: " + getPosString(value['endPos']) +
                                    "xImageCoord: " + Math.floor(xImageCoord) + " yImageCoord: " + Math.floor(yImageCoord)}
                                </Stack>
                            )
                            drawCircle(x, y, radius, this.layer.getSource(), "",
                                12, color, popup, textColor);
                            drawLine(x, y - radius, 1, this.layer.getSource(),
                                "z: " + value['startPos']['zPosition'], 10, "#E9D6C5",
                                "", textColor, textSize);

                            if (value['traceID'] === 1) {
                                drawCircle(x, y, 0.1 * tile_height * uperpixel, this.layer.getSource(), "",
                                    12, color, "", textColor);
                            }
                            if (value['islandId'] > 1000) {
                                drawLine(x + (-0.2 * tile_width * uperpixel), y + (0.4 * tile_height * uperpixel),
                                    1, this.layer.getSource(), value['islandId'], 1,
                                    "#ffff00", "", textColor);
                            } else if (value['islandId']) {
                                drawLine(x + (0.4 * tile_width * uperpixel), y + (0.4 * tile_height * uperpixel),
                                    1, this.layer.getSource(), value['islandId'], 1,
                                    "#00ffea", "", textColor);
                            }
                        }
                    });
                }
            });
        });
        resolve();
    });
}

export default T0Streak;
